const mergeConfig = (base: any, override: any): any => ({
  ...(base ?? {}),
  ...(override ?? {}),
});

export const getChatConfig = (config: any): any => {
  if (config?.chat_config) {
    return config.chat_config;
  }

  const chatConfig = mergeConfig(
    config?.platforms?.all?.chat_config,
    config?.platforms?.web?.chat_config
  );

  return mergeConfig(chatConfig, {
    maintenance: config?.maintenance?.includes("web")
      ? chatConfig?.maintenance
      : null,
  });
};
